import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Collapse,
  TablePagination,
} from "@mui/material";
import { Notifications, CalendarToday, Home } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { VendorappBar } from "../../../components";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../../hooks";

const statusColors = {
  High: "red",
  Medium: "orange",
  Low: "green",
};

export default function CommunicationManagement({ onBackScreenName }) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [complaints, setComplaints] = useState([]);
  const [data, setData] = useState("");
  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);
  const [newComplaint, setNewComplaint] = useState({
    name: "",
    description: "",
    image: [],
    status: "Low",
  });
  const initializeComplaints = () => {
    setNewComplaint({
      name: "",
      description: "",
      image: [],
      status: ""
    });
  };
  const [snackbarState, setSnackbarState] = useState({
      message: "",
      status: "",
    });
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [errors, setErrors] = useState({});
  const [isEditMode, setEditMode] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isImageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const clearErrors = () => {
    setErrors({});
  };
  //get All Vendor Complaints data
  useEffect(() => {
    fetchData();
  }, []);

  //get All Vendor Complaints data
  const {
    data: complaintsData,
    isLoading: iscomplaintsLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllVendorComplaints"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createComplaintsData,
    isLoading: createComplaintsLoading,
    error: createComplaintsError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVendorComplaints"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (complaintsData && complaintsData["status"] === true) {
      console.log("complaintsData", complaintsData);
      setData(complaintsData["data"] || []);
    }
  }, [complaintsData, error]);

  //Create Complaints
  useEffect(() => {
    if (createComplaintsError) {
    } else if (
      createComplaintsData &&
      createComplaintsData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: createComplaintsData["message"],
        status: createComplaintsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (
      createComplaintsData &&
      createComplaintsData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: createComplaintsData["message"],
        status: createComplaintsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createComplaintsData, createComplaintsError]);

  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.complaint_id - a.complaint_id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.complaint_id &&
                item.complaint_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.name &&
                item.name.toLowerCase().includes(search.toLowerCase()))
          )
      : data;

  const handleImageUpload1 = (e) => {
    const file = e.target.files[0];

    if (file) {
      setNewComplaint((prevData) => ({
        ...prevData,
        image: URL.createObjectURL(file),
      }));
      setSelectedImages(file);
    }
  };
  const handleImageUpload = (e) => {
    const files = e.target.files;

    if (files.length > 0) {
      const newImages = Array.from(files).map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));

      setNewComplaint((prevData) => ({
        ...prevData,
        image: [...prevData.image, ...newImages], 
      }));
    }
  };
 
  const handleRemoveImage = (index) => {
    const updatedImages = newComplaint.image.filter((_, i) => i !== index);
    setNewComplaint((prevData) => ({
      ...prevData,
      image: updatedImages, 
    }));
  };


  const handleAdd = () => {
    setEditMode(false);
    initializeComplaints();
    setErrors({});
    setOpenDialog(true);
  };

  const handleAddComplaint = () => {
    let validationErrors = {};
    if (!newComplaint["name"] || !newComplaint["name"].trim()) {
      validationErrors.name = "Complaint name is required.";
      setErrors(validationErrors);
      return;
    }

    if (!newComplaint["description"] || !newComplaint["description"].trim()) {
      validationErrors.description = "Description is required.";
      setErrors(validationErrors);
      return;
    }

    if (!newComplaint.image || newComplaint.image.length === 0) {
      validationErrors.imageError = "Complaint image is required.";
     
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (!newComplaint.status) {
      validationErrors.status = "Please select status.";
      setErrors(validationErrors);
      return;
    }
    clearErrors();

     const formdata = new FormData();
        formdata.append("name", newComplaint["name"]);
        formdata.append("description", newComplaint["description"]);
        formdata.append("complaint_status", newComplaint["status"]);
        formdata.append("reason", newComplaint["reason"] ? newComplaint["reason"] : "Support team will update the issue");
        formdata.append("vendor_id", userDetails.id);
        if (newComplaint.image && newComplaint.image.length > 0) {
          newComplaint.image.forEach((image) => {
            formdata.append("images", image.file);
          });
        }
    if (!isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
      }
      fetchCreateData(formdata);
    }
  };
  const handleAddComplaint1 = () => {
    if (
      !newComplaint.name ||
      !newComplaint.description ||
      !newComplaint.image
    ) {
      alert("Please fill in all fields, including uploading an image.");
      return;
    }

    setComplaints([
      ...complaints,
      {
        ...newComplaint,
        id: Date.now(),
        image: URL.createObjectURL(newComplaint.image),
      },
    ]);
    setNewComplaint({
      name: "",
      description: "",
      image: null,
      status: "Low",
    });
    setOpenDialog(false);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setNewComplaint({ name: "", description: "", image: null, status: "Low" });
  };
  const [openRows, setOpenRows] = useState({});

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
    setImageModalOpen(true);
  };

  const handleImageModalClose = () => {
    setImageModalOpen(false);
    setSelectedImageUrl("");
  };
  const handleClose = () => {
    setModalOpen(false);
    clearErrors();
    if (createComplaintsData && createComplaintsData["status"] === true) {
      initializeComplaints();
      setOpenDialog(false);
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* AppBar */}
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Communication Management
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}
        <VendorappBar
          title={"Communication Management"}
          onBackScreenName={handleScreeName}
        />

        <Grid container spacing={2} justifyContent="flex-start">
          {/* Card 1 */}
          <Grid item xs={12} sm={5} md={4}>
            <Card
              sx={{
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                p: 2,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mb: 1, color: "black" }}
                >
                  Customer Support
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "black",
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PhoneIcon sx={{ marginRight: 1 }} /> 9247276921
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Card 2 */}
          <Grid item xs={12} sm={5} md={4}>
            <Card
              sx={{
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                p: 2,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mb: 1, color: "black" }}
                >
                  Customer Support
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "black",
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <EmailIcon sx={{ marginRight: 1 }} /> vasanth@gmail.com
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Complaint Table */}
        <Box sx={{ p: 2, backgroundColor: "#fff", mt: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <TextField
              variant="outlined"
              placeholder="Search"
              size="small"
              value={search}
              onChange={handleSearch}
              sx={{
                width: "30%",
                backgroundColor: "#FFF",
                borderRadius: 1,
              }}
            />
            <Button
              variant="contained"
              color="success"
              onClick={handleAdd}
            >
              Add Complaint
            </Button>
          </Box>

          <TableContainer
            component={Paper}
            sx={{ borderRadius: "20px", mt: 2 }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="complaints table">
              <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Complaint ID
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Complaint Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Priority</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Typography>No records found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData

                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((complaint) => {
                      return (
                        <React.Fragment key={complaint.complaint_id}>
                          <TableRow>
                            <TableCell>{complaint.complaint_id}</TableCell>
                            <TableCell>{complaint.name}</TableCell>
                            <TableCell>{complaint.description}</TableCell>
                            <TableCell>
                            {complaint.images && complaint.images.length > 0 ? (
    complaint.images.map((image, index) => (
      <img
        key={image.complaint_image_id}
        src={image.image_url}
        alt={`image-${index}`}
        width={40}
        height={40}
        style={{
          marginRight: '5px',
          cursor: 'pointer',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }}
        onClick={() => handleImageClick(image.image_url)}
        title="Click to expand image"
      />
    ))
  ) : (
    "No Image"
  )}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: statusColors[complaint.complaint_status],
                                fontWeight: "bold",
                              }}
                            >
                              {complaint.complaint_status}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() =>
                                  toggleRow(complaint.complaint_id)
                                }
                              >
                                {openRows[complaint.complaint_id] ? (
                                  <KeyboardArrowUpIcon />
                                ) : (
                                  <KeyboardArrowDownIcon />
                                )}
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              colSpan={5}
                              sx={{ paddingBottom: 0, paddingTop: 0 }}
                            >
                              <Collapse
                                in={openRows[complaint.complaint_id]}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Box sx={{ margin: 1 }}>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    Reason:
                                  </Typography>
                                  <Typography>{complaint.reason}</Typography>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: "bold", mt: 1 }}
                                  >
                                    Status:
                                  </Typography>
                                  <Typography>
                                    {complaint.status == 1
                                      ? "Active"
                                      : complaint.status == 0
                                      ? "Inactive"
                                      : ""}
                                  </Typography>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={complaints.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Box>

      {/* Dialog to Add Complaint */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Add New Complaint</DialogTitle>
        <DialogContent>
          <TextField
            label="Complaint Name"
            fullWidth
            variant="outlined"
            sx={{ mb: 1,mt:1 }}
            
            name="name"
            value={newComplaint.name}
            onChange={(e) =>
              setNewComplaint({
                ...newComplaint,
                name: e.target.value,
              })
            }
            error={!!errors.name}
            helperText={
              errors.name && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.name}
                </Typography>
              )
            }
          />

          <TextField
            label="Complaint Description"
            fullWidth
            variant="outlined"
            sx={{ mb: 2,mt:1 }}
            name="description"
            value={newComplaint.description}
            onChange={(e) =>
              setNewComplaint({
                ...newComplaint,
                description: e.target.value,
              })
            }
            error={!!errors.description}
            helperText={
              errors.description && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.description}
                </Typography>
              )
            }
          />

          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            style={{ marginBottom: "16px" }}
          />
         
          {newComplaint.image && newComplaint.image.length > 0 ? (
          newComplaint.image.map((image, index) => (
            <div key={index} style={{ marginBottom: '8px' }}>
              <img
                src={image.preview} // Use the preview URL here
                alt={`Preview ${index}`}
                width={50}
                height={50}
              />
              <button onClick={() => handleRemoveImage(index)}>Remove</button>
            </div>
          ))
        ) : (
          <p>No images uploaded</p>
        )}
          {errors.imageError && (
            <helperText>
              <Typography
                sx={{
                  mt: 2,
                  color: "red",
                  fontSize: 12,
                }}
              >
                {errors.imageError}
              </Typography>
            </helperText>
          )}

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              id="status-select"
              value={newComplaint?.status || ""}
              onChange={(e) =>
                setNewComplaint({
                  ...newComplaint,
                  status: e.target.value,
                })
              }
              label="Status"
            >
              <MenuItem value="High">High</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="Low">Low</MenuItem>
            </Select>
            {errors.status && (
            <helperText>
              <Typography
                sx={{
                  mt: 2,
                  color: "red",
                  fontSize: 12,
                }}
              >
                {errors.status}
              </Typography>
            </helperText>
          )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button
            onClick={handleAddComplaint}
            variant="contained"
            color="primary"
          >
            Add Complaint
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Expansion Modal */}
      <Dialog
        open={isImageModalOpen}
        onClose={handleImageModalClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Complaint Image
          <IconButton
            onClick={handleImageModalClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            ×
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', p: 2 }}>
          {selectedImageUrl && (
            <img
              src={selectedImageUrl}
              alt="Expanded complaint image"
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleImageModalClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
